import React from "react";
import { useState } from "react";
import Tilt from 'react-parallax-tilt';
import Lottie from "lottie-react";
import animationData from "../../MyAnimations/Education.json"
const ProjectDetailsArea = () => {
    const [isMobile, setIsMobile] = useState(window.innerWidth < 670);
  return (
    <div className="services-details-area" style={{backgroundColor : "#292930", color :"white"}}>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-8 col-lg-10">
          <div className="services-details-img text-center" style={{display : "flex", justifyContent : "center", alignItems : "center"}}>
        {/* <img src="/img/images/services_details_img.png" alt="" />  */}
        <Lottie animationData={animationData} loop={true} style={{ width: isMobile ? "110%" : "70%", height: isMobile ? "110%" : "70%" }} />
    </div>

            <div className="services-details-content text-center">
              <p>
              My projects reflect hands-on experience in building innovative, real-time applications, showcasing my proficiency in modern tech stacks, problem-solving, and translating ideas into functional, impactful solutions.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="services-details-shape">
        <img src="/img/images/services_details_shape.png" alt="" />
      </div>
    </div>
  );
};

export default ProjectDetailsArea;
